import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withRetries } from "./retryingBaseQuery";

const maxCacheInSeconds = 0;
const maxRetries = 2;

const baseQuery = withRetries(
  fetchBaseQuery({
    baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
  }),
  maxRetries,
);

export const countriesStatesCitiesAPI = createApi({
  reducerPath: "countriesStatesCitiesAPI",
  baseQuery,
  keepUnusedDataFor: maxCacheInSeconds,
  endpoints: (builder) => ({
    //* ************************************** */
    //* GET ALL COUNTRIES */
    getCountries: builder.mutation({
      query: () => ({
        url: "https://countriesnow.space/api/v0.1/countries/codes",
        method: "GET",
      }),
    }),
    //* ************************************** */
    //* GET ALL STATES */
    getStates: builder.mutation({
      query: (country: string) => ({
        url: "https://countriesnow.space/api/v0.1/countries/states",
        method: "POST",
        body: { country },
      }),
    }),
    //* ************************************** */
    //* GET ALL CITIES */
    getCities: builder.mutation({
      query: (body: any) => ({
        url: "https://countriesnow.space/api/v0.1/countries/state/cities",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetCountriesMutation, useGetCitiesMutation, useGetStatesMutation } =
  countriesStatesCitiesAPI;
